module.exports = __webpack_public_path__ + "static/media/p3ru.7bfd7dd4.pdf";